import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import UpdatingBlock from 'components/common/UpdatingBlock/UpdatingBlock'
import { BREADCRUMB_ID } from './constants'
import { BOTBreadcrumbSimple } from 'components/Breadcrumbs/'
import { ServiceCategoriesList, ServiceCategoryPage } from './components'
import { getServiceCategoryURL } from './helpers'

const StoreServices = ({
  title = '',
  description = '',
  services: storeServices = [],
  serviceCategories = [],
  storeBaseURL,
  isLoading,
  displayServiceCategory,
  storeCityAndState,
  serviceCategory: {
    categoryId,
    categoryName,
    categoryLongDescription,
    serviceUrl
  } = {},
  onClick: handleApptRequestClick,
  updateServicesSection
}) =>
  <StoreServicesWrapper>
    <Breadcrumb id={ BREADCRUMB_ID }>
      <BOTBreadcrumbSimple
        displayName="All Services"
        link={{ path: storeBaseURL }}
        active={ !displayServiceCategory }
        onClick={ e => updateServicesSection(e) } />
      { displayServiceCategory &&
        <BOTBreadcrumbSimple
          displayName={ categoryName }
          link={{ path: storeBaseURL + getServiceCategoryURL(categoryId, serviceCategories) }}
          active
          onClick={ e => e.preventDefault() } />
      }
    </Breadcrumb>
    <UpdatingBlock condition={ isLoading }>
      { !displayServiceCategory
        ? (
          <ServiceCategoriesList
            title={ title }
            description={ description }
            storeServices={ storeServices }
            serviceCategories={ serviceCategories }
            storeBaseURL={ storeBaseURL }
            updateServicesSection={ updateServicesSection } />
        )
        : (
          <ServiceCategoryPage
            categoryId={ categoryId }
            categoryName={ categoryName }
            categoryLongDescription={ categoryLongDescription }
            serviceUrl={ serviceUrl }
            storeBaseURL={ storeBaseURL }
            storeCityAndState={ storeCityAndState }
            navigationHandler={ updateServicesSection }
            handleApptRequestClick={ handleApptRequestClick } />
        )
      }
    </UpdatingBlock>
  </StoreServicesWrapper>

StoreServices.propTypes = {
  description: PropTypes.string,
  displayServiceCategory: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  serviceCategories: PropTypes.arrayOf(PropTypes.shape()),
  serviceCategory: PropTypes.shape(),
  services: PropTypes.arrayOf(PropTypes.shape()),
  storeBaseURL: PropTypes.string,
  storeCityAndState: PropTypes.string,
  title: PropTypes.string,
  updateServicesSection: PropTypes.func
}

export default StoreServices

const StoreServicesWrapper = styled.div`
  ${Mixin.clearFix()}
`

const Breadcrumb = styled.div`
  padding-bottom: 10px;
`
